import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message); setDone(true); setEmail("");
    } catch { toast.error("Iscrizione non riuscita, riprova."); }
    finally { setSending(false); }
  };

  return (
    <div data-testid="newsletter-box">
      <p className="overline mb-4">Newsletter Soci</p>
      <p className="text-sm text-[#6E6865] mb-4 leading-relaxed">Ricevi il programma delle serate ogni settimana.</p>
      {done ? (
        <p data-testid="newsletter-success" className="text-sm text-[#D4AF37]">Grazie, sei tra i nostri soci informati.</p>
      ) : (
        <form onSubmit={submit} className="flex gap-2">
          <div className="relative flex-1">
            <Mail className="w-4 h-4 text-[#D4AF37]/60 absolute left-3 top-1/2 -translate-y-1/2" />
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="La tua email"
              data-testid="newsletter-email-input"
              className="w-full pl-9 pr-3 py-2.5 rounded-full bg-[#141217] border border-[#D4AF37]/20 text-[#FBF8F5] text-sm outline-none focus:border-[#D4AF37]" />
          </div>
          <button type="submit" disabled={sending} data-testid="newsletter-submit-btn"
            className="px-5 py-2.5 rounded-full bg-[#7A1426] hover:bg-[#941B30] text-[#F3E5AB] text-sm font-semibold border border-[#D4AF37]/30 disabled:opacity-60 transition-colors">
            {sending ? "..." : "Iscriviti"}
          </button>
        </form>
      )}
    </div>
  );
}
